import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import axios from "axios";
import Swal from "sweetalert2";

import axiosConfig from "../../axiosConfig";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import WarningIcon from "@material-ui/icons/Warning";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import "../Forms/Forms.css";
import AddCredentials from "../../shared/AddCredentials";
import * as actions from "../../store/actions/index";
import Loading from "../Loading/loading";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import SensitiveData from "../Alerts/SensitiveData";
import * as alertTypes from "../../shared/language.json";

const useStyles = makeStyles(styles);

function ModalForAlertTakeOver(props) {
  const [state, setState] = useState({
    tookOver: false,
    closed: false,
  });

  const [Alert, setAlert] = useState([]);
  const [alertForm, setalertForm] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openCredentialsSensitiveData, setOpenCredentialsSensitiveData] = useState(false);
  const [lastKnownLocation, setLastKnownLocation] = useState();
  const [openSensitiveData, setOpenSensitiveData] = useState();
  const [openCredentialsLastLocation, setOpenCredentialsLastLocation] = useState(false);
  const [verifiedUserId, setVerifiedUserId] = useState();
  const [openCredentialsSeverity, setOpenCredentialsSeverity] = useState(false);
  const [alarmSeverity, setAlarmSeverity] = useState();
  const [severityValues, setSeverityValues] = useState();
  const [filteredValues, setFilteredValues] = useState();
  const [hasAlarmSeverityChanged, setHasAlarmSeverityChanged] = useState(false);
  const [severitySubmitted, setSeveritySubmitted] = useState(false);
  const [incidentΗandlerΙnformation, setIncidentΗandlerΙnformation] = useState();

  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    if (props.location.selected) {
      localStorage.setItem("id", props.location.selected);
    }
  }, []);

  useEffect(() =>{
    if(localStorage.getItem("incidentΗandlerΙnformation")){
      setIncidentΗandlerΙnformation(JSON.parse(localStorage.getItem("incidentΗandlerΙnformation")))
    }
  }, [])

  useEffect(() => {
    if (props.location.selected || localStorage.getItem("id")) {
      const getAlarm = axiosConfig.get(
        `/Alarm/${props.location.selected
          ? props.location.selected
          : localStorage.getItem("id")
        }`
      );
      const getSeverityValues = axiosConfig.get('/AlarmSeverity');
      axios
        .all([getAlarm, getSeverityValues])
        .then(
          axios.spread((...res) => {
            const responseAlert = res[0];
            const responseSeverityValues = res[1];
            setAlert(responseAlert.data);
            setAlarmSeverity({ id: responseAlert.data.severityId, description: responseAlert.data.alarmSeverity })
            setSeverityValues(responseSeverityValues.data)
            setFilteredValues(responseSeverityValues.data.filter(severity => severity.id >= responseAlert.data.severityId))
            setLoading(false);
          })
        )
        .catch((err) => {
          console.log(err);
        });
    } else { history.goBack() }
  }, []);

  const handleCloseSensitiveData = () => {
    setOpenSensitiveData(false)
  }
  const handleChange = (event) => {
    if(incidentΗandlerΙnformation){
      setIncidentΗandlerΙnformation({...incidentΗandlerΙnformation,  [event.target.name]: event.target.checked })
      localStorage.setItem('incidentΗandlerΙnformation', JSON.stringify(incidentΗandlerΙnformation))
    }else setState({ ...state, [event.target.name]: event.target.checked });
  };

  const updateAssignmentComments = (e) => {
    if(incidentΗandlerΙnformation){
      setIncidentΗandlerΙnformation({...incidentΗandlerΙnformation, [e.target.name]: e.target.value })
      localStorage.setItem('incidentΗandlerΙnformation', JSON.stringify(incidentΗandlerΙnformation))
    }
    setalertForm({
      ...alertForm.assignmentComments,
      [e.target.name]: e.target.value,
    });
  };

  const updateClosedComments = (e) => {
    if(incidentΗandlerΙnformation){
      setIncidentΗandlerΙnformation({...incidentΗandlerΙnformation, [e.target.name]: e.target.value })
      localStorage.setItem('incidentΗandlerΙnformation', JSON.stringify(incidentΗandlerΙnformation))
    }
    setalertForm({
      ...alertForm.closedComments,
      [e.target.name]: e.target.value,
    });
  };

  const getLastLocation = useCallback((userId) => {
    const values = {
      id: Alert.deviceId,
      verifiedUserId: userId
    }
    axiosConfig.post(`/Alarm/LastKnownLocation`, values).then((res) => {
      setLastKnownLocation(res.data)
      if (res.data) {
        history.push({
          pathname: "/last-known-location",
          data: {
            lastKnownLocation: res.data
          }
        })
      } else {
        Swal.fire('Δεν βρέθηκε γνωστή τοποθεσία');
      }
    }).catch(() => Swal.fire('Δεν βρέθηκε γνωστή τοποθεσία'))
  }, [Alert, verifiedUserId])

  const handleOpenCredentialsSensitiveData = () => {
    setOpenCredentialsSensitiveData(true)
  }

  const showCredentialsForLastLocation = () => {
    setOpenCredentialsLastLocation(true);
  }

  const handleSubmitClick = () => {
    if(localStorage.getItem('incidentΗandlerΙnformation') === null){
      localStorage.setItem('incidentΗandlerΙnformation', JSON.stringify ({comments: alertForm.comments, tookOver: state.tookOver, closed: state.closed}))
    }
    if (state.tookOver === true) {
      alertForm.statusId = 2;
    } else alertForm.statusId = 3;
    alertForm.id = props.location.selected ? props.location.selected : localStorage.getItem("id");
    alertForm.deviceId = Alert.deviceId;
    alertForm.dateCreated = Alert.statusId === 1 ? Alert.dateCreated : null;
    alertForm.dateAssigned = Alert.statusId === 2 ? Alert.assignmentDate : null;

  };
  const handleClickOpen = () => {
    if (
     ( 
       (state.tookOver || state.closed ) &&
      alertForm.comments !== undefined &&
      alertForm.comments.length > 5 &&
      (hasAlarmSeverityChanged === false)
    ) ||
      (
      incidentΗandlerΙnformation?.tookOver || incidentΗandlerΙnformation?.closed) &&
      incidentΗandlerΙnformation?.comments !== undefined &&
      incidentΗandlerΙnformation?.comments.length> 5 &&
      (hasAlarmSeverityChanged === false)
    ) {
      axiosConfig
        .post("/Alarm/GetAlarmsFromDeviceByAlarmId", {
          id: props.location.selected
            ? props.location.selected
            : localStorage.getItem("id"),
          deviceId: Alert.deviceId,
          statusId: Alert.statusId,
          dateCreated: Alert.statusId === 1 ? Alert.dateCreated : null,
          dateAssigned: Alert.statusId === 2 ? Alert.assignmentDate : null
        })
        .then((res) => {
          let data = res.data;
          history.push({
            pathname: "/all-alerts-takeover",
            data: data,
            alarmWidget: Alert,
            alertForm: alertForm,
            localPath: props.location.localPath
          });
        });
    } else {
      if (
        alertForm.comments === undefined ||
        state.tookOver === false ||
        state.closed === false ||
        incidentΗandlerΙnformation.tookOver === false||
        incidentΗandlerΙnformation.closed === false
        
      )
        Swal.fire("Δεν έχετε συμπληρώσει τα απαραίτητα πεδία.", "", "info");
    }
    if (alertForm.comments !== undefined && alertForm.comments.length <= 5) {
      Swal.fire(
        "Συμπληρώστε τουλάχιστον 6 χαρακτήρες στις παρατηρήσεις.",
        "",
        "info"
      );
    }
    if((hasAlarmSeverityChanged === true && severitySubmitted === false)){
      Swal.fire("Δεν έχετε ενημερώσει τον δείκτη κινδύνου.", "", "info");
    }
  };
  const handleClickClose = () => {
    setOpen(false);
  };

  const handleCloseCredentialsSensitiveData = (userIdVerified) => {
    setOpenCredentialsSensitiveData(false);
    setVerifiedUserId(userIdVerified);
    if (userIdVerified) {
      setOpenSensitiveData(true)
    }
  }

  const handleCloseLastLocationCredentials = (userIdVerified) => {
    setOpenCredentialsLastLocation(false);
    setVerifiedUserId(userIdVerified);
    if(userIdVerified){
      getLastLocation(userIdVerified);
    }
  };

  const putSeverity = (userId) => {
    const values = {
      id: Alert.id,
      severityId: alarmSeverity.id,
      verifiedUserId: userId
    }
    if (userId) {
      Swal.fire({
        title: "",
        text: "Έχετε επιλέξει να αναβαθμίσετε τον Δείκτη Κινδύνου. Είστε βέβαιοι;",
        icon: "warning",
        position: "center",
        showCancelButton: true,
        container: "container-class",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι"
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "",
            text: "Παρακαλούμε επιβεβαιώστε την καταχώρηση σας.",
            icon: "warning",
            position: "center",
            showCancelButton: true,
            container: "container-class",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ναι",
            cancelButtonText: "Οχι",
          }).then((result) => {
            if (result.value) {
              axiosConfig.put('/Alarm/AlarmSeverity', values).then((res) => {
                setAlert({
                  ...Alert,
                  severityId: alarmSeverity.id,
                  alarmSeverity: alarmSeverity.description
                })
                setFilteredValues(severityValues.filter(severity => severity.id >= alarmSeverity.id))
                setSeveritySubmitted(true)
                setHasAlarmSeverityChanged(false);
              }).catch(() => Swal.fire('Η καταχώρηση απέτυχε'))
            }
          });
        }
      })

    }
  };

  const handleCloseSeverityCredentials = (userIdVerified) => {
    setOpenCredentialsSeverity(false);
    setVerifiedUserId(userIdVerified);
    putSeverity(userIdVerified);
  };

  const handleChangeSeverity = (event) => {
    const selectedValue = severityValues.find(x => x.id === event.target.value)
    setAlarmSeverity(selectedValue)
    setHasAlarmSeverityChanged(true)
  };

  const handleOpenCredentialsSeverity = () => {
    setOpenCredentialsSeverity(true);
  };
  if (loading === false) {
    return (
      <div>
        <form className="Form">
          <Card>
            <CardHeader color="warning">
              <h1 className={classes.cardTitleWhite}>
                {Alert.statusId === 1
                  ? "Ειδοποίηση προς Ανάληψη"
                  : Alert.statusId === 2
                    ? "Ειδοποίηση προς Κλείσιμο"
                    : "Ειδοποίηση σε Ιστορικό"}
              </h1>
            </CardHeader>

            <CardBody>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="deviceType"
                    label="Τύπος Συσκευής"
                    fullWidth
                    variant="outlined"
                    value={Alert.deviceType}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="id"
                    name="id"
                    label="Αρ. Ειδοποίησης"
                    value={Alert.id}
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="dateCreated"
                    name="dateCreated"
                    label={alertTypes.LABELS.DATEALERT}
                    value={Alert.dateCreated}
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth className={classes.formControl}>
                    <InputLabel  id="demo-simple-select-label">Δείκτης Κινδύνου</InputLabel>
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={alarmSeverity.id}
                      onChange={handleChangeSeverity}
                      label="Δείκτης Κινδύνου"
                    >
                      {
                        filteredValues.map((severity, index) => {
                          return <MenuItem value={severity.id}>{severity.description}</MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="alert-type"
                    name="alert-type"
                    label="Τύπος Ειδοποίησης"
                    value={Alert.alarmType}
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="alert-value"
                    name="alert-value"
                    label="Τιμή Ειδοποίησης"
                    value={Alert.value}
                    fullWidth
                    variant="outlined"
                  />
                </Grid>                
                <Grid item xs={12} sm={4}>
                  <Button                  
                    disabled={!hasAlarmSeverityChanged}
                    style={{ fontSize: '12px'}}
                    variant="contained"
                    color="primary"
                    onClick={handleOpenCredentialsSeverity}
                  >
                    Ενημερωση Δεικτη Κινδυνου
                  </Button>
                </Grid>
                {
                  openCredentialsSeverity ? (
                    <AddCredentials
                      open={openCredentialsSeverity}
                      origin='alarmSeverity'
                      close={handleCloseSeverityCredentials}
                    />
                  ) : (
                    <div />
                  )
                }

                <Grid item xs={12} sm={6}>
                  {Alert.statusId === 1 ? (
                    <Chip
                      icon={<WarningIcon style={{ color: "white" }} />}
                      label="Ανοιχτή"
                      style={{ backgroundColor: "green", color: "white" }}
                    />
                  ) : Alert.statusId === 2 ? (
                    <Chip
                      icon={<WarningIcon style={{ color: "white" }} />}
                      label="Σε Εξέλιξη"
                      style={{ backgroundColor: "orange", color: "white" }}
                    />
                  ) : (
                    <Chip
                      icon={<WarningIcon style={{ color: "white" }} />}
                      label="Κλειστή"
                      style={{ backgroundColor: "red", color: "white" }}
                    />
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                {
                  Alert.alarmType === "Πτώση" || Alert.alarmType === "Περίμετρος Ελέγχου" || Alert.alarmType === "Κουμπί SOS" ? (
                    <Grid item xs={12} >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={showCredentialsForLastLocation}
                      >
                        Εμφανιση Τελευταιας γνωστης τοποθεσιας
                      </Button>
                    </Grid>
                  )
                    : null
                }
                {
                  openCredentialsLastLocation ? (
                    <AddCredentials
                      open={openCredentialsLastLocation}
                      origin='lastKnownLocation'
                      lastKnownLocation={lastKnownLocation}
                      close={handleCloseLastLocationCredentials}
                    />
                  ) : (
                    <div />
                  )
                }
                <Grid item xs={12} >
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="beneficiaryId"
                    name="beneficiaryId"
                    label="Κωδ. Ωφελούμενου"
                    value={Alert.beneficiaryId}
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="age"
                    name="age"
                    label="Ετών"
                    type="number"
                    fullWidth
                    value={Alert.age}
                    autoComplete="age"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    disabled
                    id="genderId"
                    name="genderId"
                    label="Φύλο"
                    type="text"
                    fullWidth
                    value={(Alert.genderId === 1) ? 'Άντρας' : 'Γυναίκα'}
                    autoComplete="age"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleOpenCredentialsSensitiveData()
                    }}
                  >
                    ΕΜΦΑΝΙΣΗ ΕΥΑΙΣΘΗΤΩΝ ΠΛΗΡΟΦΟΡΙΩΝ
                  </Button>
                </Grid>
                {openCredentialsSensitiveData ? (
                  <AddCredentials
                    open={openCredentialsSensitiveData}
                    origin='sensitiveData'
                    close={handleCloseCredentialsSensitiveData}
                  />
                ) : (
                  <div />
                )}
                {openSensitiveData ?
                  <SensitiveData
                    beneficiaryId={Alert.beneficiaryId}
                    open={openSensitiveData}
                    close={handleCloseSensitiveData}
                    userId={verifiedUserId}
                    alertAge={Alert.age}
                    alertGender={Alert.genderId}
                  />
                  : <div />
                }
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid
                  container
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  {Alert.statusId === 1
                    ? [
                      <Grid item xs={12} lg={4} style={{ padding: "20px" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                incidentΗandlerΙnformation? 
                                incidentΗandlerΙnformation.tookOver:
                                 state.tookOver}
                              onChange={handleChange}
                              name="tookOver"
                              color="primary"
                              value={ incidentΗandlerΙnformation? 
                                incidentΗandlerΙnformation.tookOver:
                                 state.tookOver}
                            />
                          }
                          label="Ανάληψη"
                        />
                      </Grid>,
                      <Grid item xs={6} lg={4} style={{ padding: "20px" }}>
                        <TextField
                          placeholder
                          disabled
                          id="dateTookOver"
                          name="dateTookOver"
                          label="Ημερομηνία"
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>,
                      <Grid item xs={6} lg={4} style={{ padding: "20px" }}>
                        <FormControl>
                          <TextField
                            defaultValue={incidentΗandlerΙnformation? incidentΗandlerΙnformation.comments : null}
                            multiline
                            id="remarksTook"
                            label="Παρατηρήσεις"
                            name="comments"
                            variant="outlined"
                            onChange={updateAssignmentComments}
                          />
                        </FormControl>
                      </Grid>,
                    ]
                    : Alert.statusId === 2
                      ? [
                        <Grid item xs={12} lg={3} >
                          <FormControlLabel
                            control={
                              <Checkbox
                                defaultChecked
                                indeterminate
                                inputProps={{
                                  "aria-label": "indeterminate checkbox",
                                }}
                                variant="outlined"
                                label="Disabled"
                                checked={state.tookOver}
                                name="tookOver"
                                color="primary"
                              />
                            }
                            label="Ανάληψη"
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }} >
                          <TextField
                            disabled
                            id="dateTookOver"
                            name="dateTookOver"
                            label="Ημερομηνία"
                            variant="outlined"
                            value={Alert.assignmentDate}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            disabled
                            id="assignmentUser"
                            name="assignmentUser"
                            label="Χειριστής που Ανέλαβε"
                            variant="outlined"
                            value={Alert.assignmentUser}
                          />
                        </Grid>,
                        <Grid item xs={12} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            disabled
                            id="remarksTook"
                            label="Παρατηρήσεις"
                            name="comments"
                            variant="outlined"
                            value={Alert.assignmentComments}
                          />
                        </Grid>,
                      ]
                      : [
                        <Grid item xs={12} lg={3} style={{ padding: '20px' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                defaultChecked
                                indeterminate
                                inputProps={{
                                  "aria-label": "indeterminate checkbox",
                                }}
                                variant="filled"
                                label="Disabled"
                                checked={state.tookOver}
                                name="tookOver"
                                color="primary"
                              />
                            }
                            label="Ανάληψη"
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            disabled
                            id="dateTookOver"
                            name="dateTookOver"
                            label="Ημερομηνία"
                            variant="outlined"
                            value={Alert.assignmentDate}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            disabled
                            id="assignmentUser"
                            name="assignmentUser"
                            label="Χειριστής που Ανέλαβε"
                            variant="outlined"
                            value={Alert.assignmentUser}
                          />
                        </Grid>,
                        <Grid item xs={12} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            fullWidth
                            disabled
                            id="remarksTook"
                            label="Παρατηρήσεις"
                            name="comments"
                            multiline
                            variant="outlined"
                            rows={4}
                            value={Alert.assignmentComments}
                          />
                        </Grid>,
                      ]}
                </Grid>
                <Grid
                  container
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  {Alert.statusId === 1
                    ? [
                      <Grid item xs={12} lg={4} style={{ padding: "20px" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled
                              inputProps={{
                                "aria-label": "indeterminate checkbox",
                              }}
                              variant="filled"
                              label="Disabled"
                              checked={state.closed}
                              name="closed"
                              color="primary"
                            />
                          }
                          label="Κλείσιμο"
                        />
                      </Grid>,
                      <Grid item xs={6} lg={4} style={{ padding: "20px" }}>
                        <TextField
                          disabled
                          id="dateClosed"
                          name="dateClosed"
                          label="Ημερομηνία"
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>,
                      <Grid item xs={6} lg={4} style={{ padding: "20px" }}>
                        <TextField
                          multiline
                          disabled
                          variant="outlined"
                          id="remarksClosed"
                          label="Παρατηρήσεις"
                          name="comments"
                        />
                      </Grid>,
                    ]
                    : Alert.statusId === 2
                      ? [
                        <Grid item xs={12} lg={3} style={{ padding: '20px' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={incidentΗandlerΙnformation? incidentΗandlerΙnformation.closed: state.closed}
                                onChange={handleChange}
                                name="closed"
                                color="primary"
                                value={incidentΗandlerΙnformation? 
                                incidentΗandlerΙnformation.close:
                                 state.closed}
                              />
                            }
                            label="Κλείσιμο"
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            disabled
                            id="dateClosed"
                            name="dateClosed"
                            label="Ημερομηνία"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            disabled
                            id="closureUser"
                            name="assignmclosureUserentUser"
                            label="Χειριστής που Έκλεισε"
                            variant="outlined"
                            value={Alert.closureUser}
                          />
                        </Grid>,
                        <Grid item xs={12} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            fullWidth
                            id="remarksClosed"
                            label="Παρατηρήσεις"
                            name="comments"
                            multiline
                            rows={4}
                            variant="outlined"
                            onChange={updateClosedComments}
                            defaultValue={incidentΗandlerΙnformation? incidentΗandlerΙnformation.comments: null}
                          />
                        </Grid>,
                      ]
                      : [
                        <Grid item xs={12} lg={3} style={{ padding: '20px' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                defaultChecked
                                indeterminate
                                inputProps={{
                                  "aria-label": "indeterminate checkbox",
                                }}
                                variant="filled"
                                label="Disabled"
                                checked={state.closed}
                                name="closed"
                                color="primary"
                              />
                            }
                            label="Κλείσιμο"
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            disabled
                            id="dateClosed"
                            name="dateClosed"
                            label="Ημερομηνία"
                            variant="outlined"
                            value={Alert.closureDate}
                          />
                        </Grid>,
                        <Grid item xs={6} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            disabled
                            id="closureUser"
                            name="assignmclosureUserentUser"
                            label="Χειριστής που Έκλεισε"
                            variant="outlined"
                            value={Alert.closureUser}
                          />
                        </Grid>,
                        <Grid item xs={12} lg={3} style={{ padding: '20px' }}>
                          <TextField
                            fullWidth
                            disabled
                            id="remarksClosed"
                            label="Παρατηρήσεις"
                            variant="outlined"
                            name="comments"
                            multiline
                            rows={4}
                            value={Alert.closureComments}
                          />
                        </Grid>,
                      ]}
                </Grid>
                <Grid item sm={12} style={{ textAlign: "center" }}>
                  {Alert.statusId !== 3 ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        handleClickOpen();
                        handleSubmitClick();
                      }}
                    >
                      Συνεχεια
                    </Button>
                  ) : null}
                  {open ? (
                    <AddCredentials
                      open={open}
                      alertForm={alertForm}
                      close={handleClickClose}
                    />
                  ) : (
                    <div />
                  )}
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </form>
      </div>
    );
  } else {
    return <Loading></Loading>;
  }
}


const mapStateToProps = (state) => {
  return {
    ...state.auth,
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapPoint: (mapPointCoordinates, pointsStore, url, mapObject) => {
      dispatch(
        actions.editMapPointAsync(
          mapPointCoordinates,
          pointsStore,
          url,
          mapObject
        )
      );
    },

    editMapState: (mapPayload, editMapPoint) => {
      dispatch(actions.editMapStateAsync(mapPayload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalForAlertTakeOver);